import { useEffect } from 'react';
import HookLoader from './HookLoader/HookLoader';
import useFetch from './useFetch';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

const ResourceEnvironment = ({ resourceLoading }: any) => {
    const url = `${baseUrl}/mobilyTheme4/UtilityServlet?rv=APIGEE_BM_BASE_URL~CEM_KEY~APIGEE_BM_ X_API_KEY~APIGEE_BASE_URL~BM_PUBLIC_KEY~BM_PRIVATE_KEY`;
    const { response, error, loading }: any = useFetch(url);

    useEffect(() => {
        if (response) {
            !!!win["cem_key"] && (win["cem_key"] = response.CEM_KEY);
            !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = response.APIGEE_BASE_URL);
            !!!win["apigee_bm_base_url"] && (win["apigee_bm_base_url"] = response.APIGEE_BM_BASE_URL);
            !!!win["bm_rsa_public_key"] && (win["bm_rsa_public_key"] = response.BM_PUBLIC_KEY);
            !!!win["apigee_bm_x_api_key"] && (win["apigee_bm_x_api_key"] = response['APIGEE_BM_ X_API_KEY']);
            !!!win["errorPageURL"] && (win["errorPageURL"] = '/wps/portal/web/personal/store/error');
            resourceLoading(loading)
        }
    }, [response, loading])

    return (
        <div style={{ display: 'none' }}>
            {loading && <HookLoader loading={loading} />}
        </div>
    )
}

export default ResourceEnvironment